<template>
  <div class="equipment-change-detail">
    <div class="card">
      <div class="content">
        <div class="title">
          基本信息
          <svg-icon class="state-style" v-if="detail.AuditStatus" :class-name="detail.AuditStatus + `-icon iconfont`" :icon-class="detail.AuditStatus"></svg-icon>
        </div>
        <div class="justify-text">
          <div class="cell">
            <div class="li">申请时间</div>
            <div class="licontent">{{detail.ApplyTimeStr}}</div>
          </div>
          <div class="cell">
            <div class="li">审核时间</div>
            <div class="licontent">{{detail.AuditTimeStr}}</div>
          </div>
          <div class="textarea">
            <div class="li">审核备注</div>
            <div class="licontent">{{detail.AuditRemarks}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="content">
        <div class="title">
          详细信息
        </div>
        <div class="justify-text">
          <div class="textarea">
            <div class="li">原寝室</div>
            <div class="licontent">{{detail.OldDormitoryInfo.RegionName}}-{{detail.OldDormitoryInfo.FullAddress}}</div>
          </div>
          <div class="textarea">
            <div class="li">新寝室</div>
            <div class="licontent">{{detail.NewDormitoryInfo.RegionName}}-{{detail.NewDormitoryInfo.FullAddress}}</div>
          </div>
          <template v-if="detail.BizOrderInfo">
            <div class="cell">
              <div class="li">订单编号</div>
              <div class="licontent">{{detail.BizOrderInfo.Code}}</div>
            </div>
            <div class="cell">
              <div class="li">合同有效期</div>
              <div class="licontent">{{detail.BizOrderInfo.StartTimeStr}} ~ {{detail.BizOrderInfo.EndTimeStr}}</div>
            </div>
            <div class="cell">
              <div class="li">合同押金</div>
              <div class="licontent">{{detail.BizOrderInfo.EditDeposit}}</div>
            </div>
            <div class="cell">
              <div class="li">合同租金</div>
              <div class="licontent">{{detail.BizOrderInfo.EditPrice}}</div>
            </div>
            <div class="cell">
              <div class="li">支付时间</div>
              <div class="licontent">{{detail.BizOrderInfo.PayTimeStr}}</div>
            </div>
            <div class="cell">
              <div class="li">支付方式</div>
              <div class="licontent">{{detail.BizOrderInfo.PayType}}</div>
            </div>
            <div class="cell" v-if="detail.ContractMemberInfo">
              <div class="li">原合同新代表</div>
              <div class="licontent">{{detail.ContractMemberInfo.Name}} - {{detail.ContractMemberInfo.Mobile}}</div>
            </div>
            <div class="cell">
              <div class="li">是否带走原合同</div>
              <div class="licontent">{{detail.IsCreateStr}}</div>
            </div>
            <div class="cell">
              <div class="li">是否取消原合同</div>
              <div class="licontent">{{detail.IsCancelStr}}</div>
            </div>
            <div class="cell">
              <div class="li">是否退租原合同</div>
              <div class="licontent">{{detail.IsReturnStr}}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'equipmentChangeDetail',
  data() {
    return{
      detail: {
        OldDormitoryInfo: {},
        NewDormitoryInfo: {},
        BizOrderInfo: null,
        ContractMemberInfo: null
      }
    }
  },
  methods: {
    getDetail() {
      this.$post("/BizMemberDormitoryApply/Details", { Id: this.$route.query.Id }).then(
          (res) => {
            if (res) {
              this.detail = res.Data;
            }
          }
      );
    },
  },
  mounted() {
    this.getDetail();
  }
}

</script>

<style scoped lang="less">
.equipment-change-detail{
  .card {
    margin: 0.2rem;
    background-color: #fff;
    border-radius: 8px;
    color: #3D3D3D;

    .state-style{
      width: 80px;
      height: 80px;
      position: absolute;
      right: 20px;
      top: 60px;
    }

    .content {
      padding: 0.5rem;
      justify-content: space-between;

      .title{
        display: flex;
        font-size: 18px;
        font-weight: bold;
        align-items: center;
        color: #333333;
      }

      .van-cell__value {
        min-width: 70%;
        color: black;
      }
    }
    .rightButton {
      display: flex;
      align-items: center;
    }
  }
  .justify-text {
    .cell {
      display: flex;
      margin-top: 10px;
      width: 100%;

      >div{
        width: 100%;

        &.li{
          width: 100px;
          flex-shrink: 0;
        }
        &.licontent{
          text-align: right;
        }
      }
    }

    .textarea{
      margin-top: 10px;
      .licontent{
        margin: 5px 0;
        background-color: #FAFAFA;
        padding: 10px;
        border-radius: 8px;
      }
    }
  }
}
</style>
